import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import MainNav from 'components/common/MainNav';


class MenuMobile extends React.Component {
  constructor(props) {
    super(props);

    // Bindings
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    if (e.target.nodeName === 'A' || e.target.classList.contains('c-menu-mobile')) {
      this.props.toggleMenu();
    }
  }

  render() {
    const className = classnames({
      'c-menu-mobile': true,
      [this.props.className]: this.props.className
    });

    return (
      <div className={className} onClick={this.onClick}>
        <div className="menu">
          <button className="close-btn" onClick={() => this.props.toggleMenu()}>
            <svg className="c-icon icon-close">
              <use xlinkHref="#icon-cross"></use>
            </svg>
          </button>
          <MainNav publicationsAndDataList={this.props.publicationsAndDataList} mobile />
        </div>
      </div>
    );
  }
}

MenuMobile.propTypes = {
  className: PropTypes.string.isRequired,
  publicationsAndDataList: PropTypes.array,
  // Actions
  toggleMenu: PropTypes.func
};

export default MenuMobile;



// WEBPACK FOOTER //
// ./app/components/common/MenuMobile.jsx